// Pure helpers of the dispatch document recipients page, kept apart so they can be tested without a render.

// The group of a recipient with no carrier: it receives every carrier's documents.
export const ALL_CARRIERS = '__all__'

export const KNOWN_ERROR_CODES = ['RECIPIENT_DUPLICATED', 'RECIPIENT_INVALID', 'NOT_FOUND']

// The form fields the platform can refuse (RECIPIENT_INVALID names them in details.fields).
export const FORM_FIELDS = ['carrier_name', 'name', 'email']

export const groupKey = carrierName => carrierName || ALL_CARRIERS

// Every-carrier group first, then the warehouse's carriers (also those with nobody yet, so a carrier
// left without recipients shows as such), then any carrier only a recipient still names.
export const groupRecipients = (recipients, carriers) => {
  const byGroup = recipients.reduce((groups, recipient) => {
    const key = groupKey(recipient.carrier_name)
    return { ...groups, [key]: [...(groups[key] || []), recipient] }
  }, {})
  const extra = Object.keys(byGroup)
    .filter(key => key !== ALL_CARRIERS && !carriers.includes(key))
    .sort()
  return [ALL_CARRIERS, ...carriers, ...extra].map(key => ({ key, carrierName: key === ALL_CARRIERS ? null : key, recipients: byGroup[key] || [] }))
}

export const getErrorCode = error => error?.response?.data?.error_code || null

export const isNotFound = error => getErrorCode(error) === 'NOT_FOUND'

// The fields a failed save names: the platform's list for RECIPIENT_INVALID; a duplicate is about the email.
export const errorFields = error => {
  const code = getErrorCode(error)
  if (code === 'RECIPIENT_DUPLICATED') return ['email']
  if (code !== 'RECIPIENT_INVALID') return []
  return (error.response.data.details?.fields ?? []).filter(field => FORM_FIELDS.includes(field))
}

// The translation key of a failed write: a known platform code, a lost permission, or the generic one.
export const errorKey = error => {
  const status = error?.response?.status
  if (status === 401 || status === 403) return 'FORBIDDEN'
  const code = getErrorCode(error)
  return KNOWN_ERROR_CODES.includes(code) ? code : 'generic'
}

// Sent as typed: the platform trims and lower-cases the email, and decides whether it is valid.
export const payloadFor = ({ carrierName, name, email }) => ({
  carrier_name: carrierName === ALL_CARRIERS ? null : carrierName,
  name,
  email,
})
